import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  ogType?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function buildUrl(path: string) {
  const base = typeof window !== "undefined" ? window.location.origin : "https://example.com";
  const prefix = __BASE_PATH__.split("/").filter(Boolean).join("/");
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${base}${prefix ? `/${prefix}` : ""}${normalized === "/" ? "" : normalized}` || base;
}

export function useSeo({ title, description, keywords, path, ogType = "website", jsonLd }: SeoOptions) {
  useEffect(() => {
    document.title = title;

    const url = buildUrl(path);
    upsertMeta("name", "description", description);
    if (keywords) {
      upsertMeta("name", "keywords", keywords);
    }
    upsertMeta("name", "robots", "index,follow,max-image-preview:large");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:site_name", "黑料官方");
    upsertMeta("property", "og:url", url);

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    const scriptId = "page-jsonld";
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, path, ogType, jsonLd]);
}